// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"6":"fe3fafec","155":"c2546e90","318":"d88ed916"}[chunkId] || chunkId) + "-" + {"6":"e6ed015bcfe66085","155":"9e2c5e96b524fbd5","298":"006993fe9d819b43","318":"849eff1d357f34aa","387":"b91a6a7710661dd5"}[chunkId] + ".js";
};